import * as request from 'superagent';
// import profileTaskTypeView from "../components/profile/profile-task-type-view";

export class FeatureArea {
  key: string;
  title: string;
  description: string;
  features: Array<Feature>;
  extendedAttributes: any;
}

export class Feature {
  key: string;
  title: string;
  description: string;
  subAreaTitle: string;
  requireAssignment: boolean;
  restrictToUserType: string;
  extendedAttributes: any;
}

export class UserExtendedAttributes {
  // This is where preferences go
  showVerboseMenus?: boolean;
  alwaysItalics?: boolean;
  retainMenuCollapse?: boolean;
  authToken?: any;
}

export class UserContext {
  id: number;
  userName: string;
  firstName: string;
  middleInitial: string;
  lastName: string;
  displayName: string;
  employeeID: string;
  email: string;
  userTypeCode: number;
  userType: string;
  extendedAttributes: UserExtendedAttributes;
  featureAreas: Array<FeatureArea>;
  proxiedBy: any;
  phone: string;
}

// ATTENTION: jdouglas If adding user types, make sure to also add to /src/portal/models/user-context.go so that it can be accessed from the server Fri Dec 15 12:27:18 2017
export enum UserType {
  Internal = 0,
  Vendor = 1,
  PortalAdmin = 2,
  Integration = 3,
  Anonymous = 99
}

class PortalUser {
  _userContext?: UserContext;

  constructor(userContext?: UserContext) {
    if (userContext) {
      this._userContext = userContext;
    } else {
      if ((window as any).App) {
        // pull the user context from the window location, where we store it conventionally
        this._userContext = (window as any).App.userContext;
      }
    }
  }

  isLoggedIn(): boolean {
    if (this._userContext) {
      if(this._userContext.userType && this._userContext.userType != "Anonymous"){
        return true;
      } else {
        return false
      }
    } else {
      return false;
    }
  }

  isUserOfType(userType: UserType): boolean {
    if (this._userContext) {
      if (this._userContext.userTypeCode == userType) {
        return true;
      }
    }

    return false;
  }

  hasOneOfFeatures(features: Array<string>): boolean {
    if (this._userContext && this._userContext.userType == 'Portal Admin') {
      return true;
    }
    if (this._userContext && this._userContext.featureAreas) {
      for (let fa of this.featureAreas) {
        if (features) {
          for (let ff of features) {
            for (let f of fa.features) {
              // if (ff.indexOf(f.title) > -1 || ff.indexOf(f.key) > -1) {
              if (ff == f.title || ff == f.key) {
                return true;
              }
            }
          }
        }
      }
    }
    return false;
  }

  get featureAreas(): Array<FeatureArea> {
    if (this._userContext) {
      return this._userContext.featureAreas;
    }

    return new Array<FeatureArea>();
  }

  get userContext(): UserContext {
    let uc = new UserContext();

    if (this._userContext) {
      uc = this._userContext;
    }
    if (!uc.extendedAttributes) {
      uc.extendedAttributes = new UserExtendedAttributes();
    }

    return uc;
  }

  get userType(): string | undefined {
    if (this._userContext) {
		return this._userContext.userType
	}
	return undefined
  }

  get actionUserID(): number {
    if (this._userContext && this._userContext.proxiedBy) {
      return this._userContext.proxiedBy.id;
    }
    return this._userContext ? this._userContext.id : 0;
  }

  get actionUserName(): string {
    if (this._userContext && this._userContext.proxiedBy) {
      return this._userContext.proxiedBy.userName;
    }
    return this._userContext ? this._userContext.userName : '';
  }

  get actionUserFullName(): string {
    if (this._userContext && this._userContext.proxiedBy) {
      return `${this._userContext.proxiedBy.firstName} ${this._userContext.proxiedBy.lastName}`;
    }
    return `${this._userContext ? this._userContext.firstName : ''} ${
      this._userContext ? this._userContext.lastName : ''
    }`;
  }

  get actionUserContext(): any {
    if (this._userContext && this._userContext.proxiedBy) {
      return this._userContext.proxiedBy;
    }
    return this._userContext;
  }

  get isProxy(): boolean {
    if (this._userContext && this._userContext.proxiedBy) {
      return true;
    }
    return false;
  }

  get isProxyReadOnly(): boolean {
    if (this._userContext && this._userContext.proxiedBy) {
      if (
        this._userContext.proxiedBy.extendedAttributes['proxyAssignment'] &&
        this._userContext.proxiedBy.extendedAttributes['proxyAssignment']
          .readOnly
      ) {
        return true;
      }
    }
    return false;
  }

  save(fn?: (err: any, res: request.Response) => void): request.Request {
    // update the local user context
    (window as any).App.userContext = this.userContext;

    // now save the changes to the db
    return request
      .put('/preferences')
      .send(this.userContext)
      .end(fn);
  }
}

export default new PortalUser((window as any).App.userContext);
